// extracted by mini-css-extract-plugin
export var container = "_bs-0";
export var outlet = "_bs-1";
export var outletEnter = "_bs-2";
export var outletEnterActive = "_bs-3";
export var outletExit = "_bs-4";
export var outletExitActive = "_bs-5";